export default [
	{
		path: '/collectMoney/thirdOrder',
		component: (resolve) => require(['../index.vue'], resolve),
		meta: {
			title: '验劵核销',
			keepAlive: false,
		},
  },
  {
		path: '/collectMoney/verification',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '验劵核销',
			keepAlive: false,
		},
  },
  {
		path: '/collectMoney/registration',
		component: (resolve) => require(['../pay.vue'], resolve),
		meta: {
			title: '登记成功',
			keepAlive: false,
		},
  },
  {
		path: '/collectMoney/otherRegistration',
		component: (resolve) => require(['../otherPay.vue'], resolve),
		meta: {
			title: '登记成功',
			keepAlive: false,
		},
  },
  {
		path: '/collectMoney/verificationRecords',
		component: (resolve) => require(['../verificationRecords.vue'], resolve),
		meta: {
			title: '核销记录',
			keepAlive: false,
		},
	},
]
